import { SVGProps } from 'react';

const SvgLayoutTopPanel6 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<rect fill='currentColor' x={2} y={5} width={19} height={4} rx={1} />
				<rect
					fill='currentColor'
					opacity={0.3}
					x={2}
					y={11}
					width={19}
					height={10}
					rx={1}
				/>
			</g>
		</svg>
	);
};

export default SvgLayoutTopPanel6;
